import { DictionaryType } from '../../types';

const Dictionary: DictionaryType = {
    nb: {
        skiftSpraak: 'Press here to see the page in English',
        aktiver: 'Aktiver',
        aktiverBankId: 'Aktiver BankID',

        bankId: 'BankID',
        bankIdAvtale: 'BankID avtale',
        bankIdAvtaleAktivering: 'Aktivering',
        bankIdAvtaleGodtarVilkaar: 'Jeg har lest og akseptert avtalevilkårene.',
        bankIdAvtalePassordBeskrivelse: 'For å inngå BankID avtale må du ha kode og passord. Koden får du fra kodebrikken som du har fått i posten. Hvis du ikke har fått passord, kan du bestille det på SMS. Passordet sendes til nummeret vi har registrert på deg.',
        bankidAvtalePassordRegistrertNummer: 'Nummeret vi har registrert på deg er: ',
        bankIdAvtaleSendPassordPaSMS: 'Send passord på SMS',
        bankIdAvtaleSendPassordPaSMSerSendt: 'Passordet er sendt til {}',
        bankIdAvtaleSluttBeskrivelse1: 'Avtalen blir nå aktivert. Ved første gangs bruk skal du bruke samme passord som du fikk tilsendt og som du brukte da du godkjente avtalen. Du vil da bli bedt om å sette personlig passord. Dette skal du ikke dele med noen.',
        bankIdAvtaleSluttBeskrivelse2: 'Logg inn i nettbanken slik at du får satt ditt personlige passord!',
        bankIdAvtaleSluttTittel: 'Bekreftelse på BankID avtale',
        bankIdAvtaleVilkar: 'BankID avtalevilkår',
        lastNedBankIdAvtaleVilkarPDF: 'Last ned BankID avtalevilkår PDF',
        acceptTermsMessage: 'Du må akseptere avtalevilkårene for å kunne aktivere BankID',

        fnr: 'Fødselsnummer',
        fnrError: 'Fødselsnummer er ugyldig. skriv inn ditt fødselsnummer (11 siffer)',
        fnrPakrevd: 'skriv inn ditt fødselsnummer (11 siffer)',
        forsideBeskrivelse1: 'Her kan du aktivere din BankID med brikke, og passord som du får per SMS underveis i aktiveringen. Ved aktivering inngår du BankID-avtalen som regulerer bruken av BankID.',
        forsideBeskrivelse2: 'NB: Dersom du har mottatt en ny brikke må denne verifiseres. Du må legitimere deg ved personlig oppmøte. Husk både brikke og legitimasjon! Dersom du allerede har gjort dette kan du fortsette til aktivering av BankID.',
        kodebrikke: 'Kode fra kodebrikke',
        kodebrikkeError: 'Kode er ugyldig. skriv inn kode fra kodebrikken (6 siffer)',
        kodebrikkePakrevd: 'skriv inn kode fra kodebrikken (6 siffer)',
        neste: 'Neste',
        opsNoeGikkGalt: 'Ops! Noe gikk galt',
        passord: 'Passord',
        passordError: 'Passord er ugyldig',
        passordPakrevd: 'Vennligst skriv inn passord',
        skjulPassord: 'Skjul passord',
        startPaaNytt: 'Start på nytt',
        visMer: 'Vis mer',
        visMindre: 'Vis mindre',
        visPassord: 'Vis passord',

        /** BankId INFO **************************************/
        bankIdInfoBank: 'Bankforbindelse',
        bankIdInfoDag: 'Dag',
        bankIdInfoDager: 'Dager',
        bankIdInfoElementer: 'Sikkerhetselementer',
        bankIdInfoEmne: 'Utstedt til',
        bankIdInfoEndret: 'Oppdatert',
        bankIdInfoGyldig: 'Gyldig',
        bankIdInfoMobil: 'Mobilnummer',
        bankIdInfoRegistrert: 'Opprettet',
        bankIdInfoTittel: 'Min BankID',
        bankIdInfoTomt: 'Du har ingen BankID registrert hos oss.',
        bankIdInfoType: 'Type',
        bankIdInfoUtloper: 'BankId utløper om {} {}',
        bankIdInfoUtsteder: 'Utstedt av',
        bankIdInfoNede: 'Tjenesten er midlertidig nede for vedlikehold. Prøv igjen senere.',

        /** ENUM **************************************/

        ACTIVATION_STARTED: 'Startet aktivering',
        NO_BANKID_OR_OTP_VERIFICATION_FAILED: 'Kan ikke starte aktivering. Inntastet kode er feil, du har ikke verifisert kodebrikken ved personlig oppmøte eller du har ingen BankID som skal aktiveres. Kontakt kundeservice hvis du mener dette er feil.',
        CONTACT_DETAILS_CONVERSION_PERIOD: "Kan ikke starte aktivering. Det er mindre enn 24 timer siden du sist endret mobilnummer eller epost-adresse.",
        ORDER_ACTIVATED: 'Ordre er aktivert',
        OTP_VERIFICATION_TIMEOUT: 'Aktiveringen er utløpt, du må starte prosessen på nytt',
        PASSWORD_SENT: 'Passordet er sendt',
        PWD_TOO_MANY_ATTEMPTS: 'Feil passord er skrevet inn for mange ganger',
        WRONG_PASSWORD: 'Feil passord',
    },
    en: {
        skiftSpraak: 'Trykk her for å se siden på norsk',
        aktiver: 'Activate',
        aktiverBankId: 'Activate BankID',

        bankId: 'BankID',
        bankIdAvtale: 'BankID agreement',
        bankIdAvtaleAktivering: 'Activation',
        bankIdAvtaleGodtarVilkaar: 'I have read and accepted the agreement terms.',
        bankIdAvtalePassordBeskrivelse: 'To enter into a BankID agreement, you need a code and a password. You get the code from the otp device you received by mail. If you have not received a password, you can order one by SMS. The password will be sent to the number we have registered for you.',
        bankidAvtalePassordRegistrertNummer: 'The number we have registered for you is: ',
        bankIdAvtaleSendPassordPaSMS: 'Send password by SMS',
        bankIdAvtaleSendPassordPaSMSerSendt: 'The password has been sent to {}',
        bankIdAvtaleSluttBeskrivelse1: 'The agreement is now being activated. When you use it for the first time, you must use the same password that was sent to you and that you used when you approved the agreement. You will then be asked to set a personal password. Do not share this with anyone.',
        bankIdAvtaleSluttBeskrivelse2: 'Log in to online banking so you can set your personal password!',
        bankIdAvtaleSluttTittel: 'Confirmation of BankID agreement',
        bankIdAvtaleVilkar: 'BankID agreement terms',
        lastNedBankIdAvtaleVilkarPDF: 'Download BankID agreement terms PDF',
        acceptTermsMessage: 'You must accept the agreement terms to be able to activate BankID',

        fnr: 'National identity number',
        fnrError: 'National identity number is invalid. Enter your national identity number (11 digits)',
        fnrPakrevd: 'Enter your national identity number (11 digits)',
        forsideBeskrivelse1: 'Here you can activate your BankID with a otp device, and password that you receive during the activation process. When activating, you enter into the BankID agreement that governs the use of BankID.',
        forsideBeskrivelse2: 'Note: If you have received a new otp device, it must be verified. You must identify yourself in person. Remember both the otp device and identification! If you have already done this, you can continue to activate BankID.',
        kodebrikke: 'Code from the otp device',
        kodebrikkeError: 'The code is invalid. Enter the code from the otp device (6 digits)',
        kodebrikkePakrevd: 'Enter the code from the otp device (6 digits)',
        neste: 'Next',
        opsNoeGikkGalt: 'Oops! Something went wrong',
        passord: 'Password',
        passordError: 'Password is invalid',
        passordPakrevd: 'Please enter a password',
        skjulPassord: 'Hide password',
        startPaaNytt: 'Start over',
        visMer: 'Show more',
        visMindre: 'Show less',
        visPassord: 'Show password',

        /** BankId INFO **************************************/
        bankIdInfoBank: 'Bank',
        bankIdInfoDag: 'Day',
        bankIdInfoDager: 'Days',
        bankIdInfoElementer: 'Security elements',
        bankIdInfoEmne: 'Issued to',
        bankIdInfoEndret: 'Updated',
        bankIdInfoGyldig: 'Valid',
        bankIdInfoMobil: 'Mobile number',
        bankIdInfoRegistrert: 'Created',
        bankIdInfoTittel: 'My BankID',
        bankIdInfoTomt: 'You do not have any BankID registered with us.',
        bankIdInfoType: 'Type',
        bankIdInfoUtloper: 'BankID expires in {} {}',
        bankIdInfoUtsteder: 'Issued by',
        bankIdInfoNede: 'The service is temporarily unavailable due to maintenance. Please try again later.',

        /** ENUM **************************************/

        ACTIVATION_STARTED: 'Activation started',
        NO_BANKID_OR_OTP_VERIFICATION_FAILED: 'Unable to start activation. The code you entered is incorrect, you have not verified the otp device in person, or you do not have a BankID to activate. Contact customer service if you believe this is incorrect.',
        CONTACT_DETAILS_CONVERSION_PERIOD: 'Unable to start activation. It has been less than 24 hours since you last changed your mobile number or email address.',
        ORDER_ACTIVATED: 'Order activated',
        OTP_VERIFICATION_TIMEOUT: 'The activation has expired. You must start the process again.',
        PASSWORD_SENT: 'The password has been sent',
        PWD_TOO_MANY_ATTEMPTS: 'The wrong password has been entered too many times',
        WRONG_PASSWORD: 'Wrong password',
    }
};
export default Dictionary;
